import {useEffect, useState} from "react";
import {usePopper} from "react-popper";
import InvoiceFilterModal from "../modals/invoice/InvoiceFilterModal";
import DealFilterModal from "../modals/deal/DealFilterModal";
import { useTranslation } from "../../hooks/useTranslation";

export function DealFilter({awailableColumns, selectedColumns, toggleColumn, setFilter, filter, setShowModalNew}) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const isFilterState = (state) => {
        return filter.current_state_id.includes(state);
    }

    return (
        <div
            className="d-lg-flex justify-content-end text-end text-md-start"
            data-kt-customer-table-toolbar="base"
        >
              <span className="d-none d-md-block  me-3">
                <select className="form-select form-select-solid form-select-lg"

                        onChange={e =>
                            setFilter({...filter, current_state_id: e.target.value})
                        }
                        value={filter.current_state_id ? filter.current_state_id : ""}
                >
                    <option value="">{t("common.all")}</option>
                    <option value="1">{t("deals.confirmed")}</option>
                    <option value="2">{t("deals.closed")}</option>
                    <option value="0" >{t("deals.waitingConfirmation")}</option>
                    <option value="-1">{t("deals.rejected")}</option>
                    <option value="-2">{t("common.cancel")}</option>
                </select>
              </span>

            <button type="button" className="btn btn-primary me-3"
                    onClick={() => setShowModalNew(true)}
            >
                <i className="ki-duotone ki-plus fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>{t("deals.newRegistration")}
            </button>

            <button
                type="button"
                className="btn btn-light-primary me-3"
                onClick={() => setShowModal(true)}
            >
                <i className="ki-duotone ki-filter fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>
                {t("common.filter")}
            </button>

            <DealFilterModal
                filter={filter}
                setFilter={setFilter}
                awailableColumns={awailableColumns}
                toggleColumn={toggleColumn}
                selectedColumns={selectedColumns}
                show={showModal}
                handleClose={() => setShowModal(false)}
            />

        </div>
    )
}